import { useCallback, useMemo, useState } from 'react'
import { columnDefinitions, defaultColumnConfig, essentialColumnConfig, type ColumnVisibilityConfig } from './columns'

export function useColumnConfig(initial?: ColumnVisibilityConfig) {
  const [columnConfig, setColumnConfig] = useState<ColumnVisibilityConfig>(initial || defaultColumnConfig)

  const handleChange = useCallback((columnKey: string, checked: boolean) => {
    setColumnConfig(prev => ({ ...prev, [columnKey]: checked }))
  }, [])

  const showAll = useCallback(() => setColumnConfig({ ...defaultColumnConfig, ...Object.fromEntries(Object.keys(defaultColumnConfig).map(k => [k, true])) }), [])
  const showEssentials = useCallback(() => setColumnConfig(essentialColumnConfig), [])

  const visibleColumns = useMemo(() => columnDefinitions.filter(col => columnConfig[col.key] !== false), [columnConfig])

  return {
    columnConfig,
    setColumnConfig,
    handleChange,
    showAll,
    showEssentials,
    visibleColumns
  }
}
